import {Component, OnInit} from '@angular/core';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  message: string;
  @BlockUI() blockUI: NgBlockUI;
  constructor() {
    this.blockUI.stop();
    this.message = 'Error Occurred. Invalid request.'

  }

  ngOnInit() {

  }

}
